import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import getActiveEditorState from "editor/utils/getActiveEditorState";

/**
 * GhostConnect's purpose is to provide a way to connect custom draft components (such as QuoteAttribution)
 * Connecting draft components creates a litany of bugs cause by race conditions
 * See: https://draftjs.org/docs/advanced-topics-editorstate-race-conditions.html#content
 * Instead of connecting the draft component directly, props are passed to the ghostConnect function
 * which should set component state on the custom draft component
 */

class GhostConnect extends React.Component {
  componentDidMount() {
    this.props.ghostConnect(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    nextProps.ghostConnect(nextProps);
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => {
  return {
    editorState: getActiveEditorState(state),
  };
};

export default connect(mapStateToProps)(GhostConnect);

GhostConnect.propTypes = {
  editorState: PropTypes.object.isRequired,
  ghostConnect: PropTypes.func.isRequired,
};
